import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "food-category-manage" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center","gap":"12px"} }
const _hoisted_3 = { style: {"margin-bottom":"16px","text-align":"right"} }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "pagination-container" }
const _hoisted_7 = {
  key: 1,
  style: {"text-align":"center","padding":"16px 0"}
}

import { ref, reactive, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import { SearchOutlined, ReloadOutlined, ArrowLeftOutlined } from '@ant-design/icons-vue';
  import { message } from 'ant-design-vue';
  import zhCN from 'ant-design-vue/es/locale/zh_CN';
  import dayjs, { type Dayjs } from 'dayjs';
  import { restoreSelectedShop, cacheSelectedShop } from '@/utils/selectedShop';
  import {
    fetchCategoryList,
    addFoodCategory,
    updateFoodCategory,
    deleteFoodCategory,
    forbidFoodCategory,
    fetchFoodCategoryDetail,
    insertLanguageTranslation,
    updateLanguageTranslation,
    fetchLanguageTranslationList,
  } from '@/service/food';
  import { fetchShopList } from '@/service/base';
  import type { FoodCategoryDetailModel } from '@/model/food';

  // 表格列定义
  
export default /*@__PURE__*/_defineComponent({
  __name: 'FoodCategoryManageView',
  setup(__props) {

  const columns = [
    {
      title: '分类ID',
      dataIndex: 'shopFoodCategoryId',
      key: 'shopFoodCategoryId',
      width: 100,
    },
    {
      title: '分类名称',
      dataIndex: 'categoryName',
      key: 'categoryName',
      width: 150,
    },
    {
      title: '状态',
      dataIndex: 'categoryStatus',
      key: 'categoryStatus',
      width: 100,
    },
    {
      title: '店铺名称',
      dataIndex: 'shopName',
      key: 'shopName',
      width: 150,
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      width: 180,
    },
    {
      title: '操作',
      key: 'actions',
      width: 260,
      fixed: 'right',
    },
  ];

  // 响应式数据
  const loading = ref(false);
  const shopList = ref<any[]>([]);
  const tableData = ref<any[]>([]);
  const total = ref(0);
  const dateRange = ref<[Dayjs, Dayjs] | null>(null);
  const translationLanguageOptions = [
    { label: '英语', value: 'en' },
    { label: '法语', value: 'ja' },
  ];

  // 新增 / 编辑分类弹窗
  const categoryModalVisible = ref(false);
  const categoryModalLoading = ref(false);
  const isEdit = ref(false);
  const categoryModalTitle = ref('新增分类');
  const categoryForm = reactive({
    shopFoodCategoryId: undefined as number | undefined,
    shopId: undefined as number | undefined,
    categoryName: '',
    // categoryType 后端需要，此处固定为 1
    categoryStatus: 0 as 0 | 1,
    sort: 1 as number,
    remark: '',
    translationLanguage: 'en',
    languageTranslationId: undefined as number | undefined,
    translationCategoryName: '',
  });

  // 分类详情弹窗
  const categoryDetailVisible = ref(false);
  const categoryDetailLoading = ref(false);
  const categoryDetail = ref<FoodCategoryDetailModel | null>(null);

  // 查询参数
  const queryParams = reactive({
    createtimeBegin: '',
    createtimeEnd: '',
    pageNum: 1,
    pageSize: 20,
    data: {
      shopId: undefined as number | undefined,
      categoryName: '',
      categoryStatus: undefined as number | undefined,
    },
  });

  // 格式化日期时间
  const formatDateTime = (dateStr: string | Date | undefined) => {
    if (!dateStr) return '-';
    return dayjs(dateStr).format('YYYY-MM-DD HH:mm:ss');
  };

  // 根据店铺ID获取店铺名称（用于列表展示）
  const getShopName = (shopId?: number | string) => {
    if (!shopId) return '-';
    const idNum = Number(shopId);
    const shop = shopList.value.find((s) => s.shopId === idNum);
    return shop?.shopName || '-';
  };

  const getSelectedShop = (shopId?: number) => {
    if (!shopId) return undefined;
    return shopList.value.find((shop) => Number(shop.shopId) === Number(shopId));
  };

  const submitCategoryTranslation = async (categoryId?: number) => {
    const translationCategoryName = categoryForm.translationCategoryName.trim();
    if (!translationCategoryName) return;
    if (!categoryId || !categoryForm.shopId) {
      message.warning('分类保存成功，翻译缺少分类ID或店铺信息，未保存');
      return;
    }

    const shop = getSelectedShop(categoryForm.shopId);
    if (!shop) {
      message.warning('分类保存成功，翻译缺少店铺公司信息，未保存');
      return;
    }

    const translationJson = JSON.stringify({ categoryName: translationCategoryName });
    const resp = categoryForm.languageTranslationId
      ? await updateLanguageTranslation({
          languageTranslationId: categoryForm.languageTranslationId,
          translationJson,
          remark: categoryForm.remark || '',
        })
      : await insertLanguageTranslation({
          companyId: Number(shop.companyId || 0),
          companyName: shop.companyName || '',
          language: categoryForm.translationLanguage,
          type: 3,
          entityId: categoryId,
          entityName: categoryForm.categoryName,
          translationJson,
          remark: categoryForm.remark || '',
        });
    if (resp.code === 200) {
      message.success('分类翻译保存成功');
    } else {
      message.warning(resp.msg || '分类保存成功，翻译保存失败');
    }
  };

  const parseTranslationJson = (translationJson?: string) => {
    if (!translationJson) return undefined;
    try {
      return JSON.parse(translationJson) as { categoryName?: string };
    } catch (error) {
      console.error('解析分类翻译失败:', error);
      return undefined;
    }
  };

  const loadCategoryTranslation = async (categoryId?: number, shopId?: number) => {
    categoryForm.translationCategoryName = '';
    categoryForm.languageTranslationId = undefined;
    if (!categoryId || !shopId) return;

    const shop = getSelectedShop(shopId);
    if (!shop) return;

    try {
      const resp = await fetchLanguageTranslationList({
        pageNum: 1,
        pageSize: 20,
        data: {
          companyId: Number(shop.companyId || 0),
          language: categoryForm.translationLanguage,
          type: 3,
          status: 0,
          entityId: categoryId,
        },
      });
      if (resp.code === 200) {
        const translation = resp.result.list?.[0];
        const translationData = parseTranslationJson(translation?.translationJson);
        categoryForm.languageTranslationId = translation?.languageTranslationId;
        categoryForm.translationCategoryName = translationData?.categoryName || '';
      }
    } catch (error) {
      console.error('加载分类翻译失败:', error);
    }
  };

  const handleCategoryTranslationLanguageChange = async () => {
    categoryForm.translationCategoryName = '';
    categoryForm.languageTranslationId = undefined;
    if (isEdit.value) {
      await loadCategoryTranslation(categoryForm.shopFoodCategoryId, categoryForm.shopId);
    }
  };

  // 处理日期范围变化（开始时间传 00:00:00，结束时间传 23:59:59）
  const handleDateRangeChange = (dates: [Dayjs, Dayjs] | null) => {
    if (dates && dates[0] && dates[1]) {
      // 开始时间：当天 00:00:00
      queryParams.createtimeBegin = dates[0].startOf('day').format('YYYY-MM-DD HH:mm:ss');
      // 结束时间：当天 23:59:59
      queryParams.createtimeEnd = dates[1].endOf('day').format('YYYY-MM-DD HH:mm:ss');
    } else {
      queryParams.createtimeBegin = '';
      queryParams.createtimeEnd = '';
    }
  };

  // 加载店铺列表
  const loadShopList = async () => {
    try {
      const response = await fetchShopList({
        pageNum: 1,
        pageSize: 999,
        data: { shopStatus: 0 },
      });
      if (response.code === 200) {
        shopList.value = response.result.list || [];
        queryParams.data.shopId = restoreSelectedShop(shopList.value);
      }
    } catch (error) {
      console.error('加载店铺列表失败:', error);
      message.error('加载店铺列表失败');
    }
  };

  // 加载分类列表
  const loadCategoryList = async () => {
    if (!queryParams.data.shopId) {
      tableData.value = [];
      total.value = 0;
      message.warning('请选择餐厅');
      return;
    }
    try {
      loading.value = true;

      // 构建查询参数，过滤掉空值
      const params: any = {
        pageNum: queryParams.pageNum,
        pageSize: queryParams.pageSize,
        data: {},
      };

      // 添加时间范围
      if (queryParams.createtimeBegin) {
        params.createtimeBegin = queryParams.createtimeBegin;
      }
      if (queryParams.createtimeEnd) {
        params.createtimeEnd = queryParams.createtimeEnd;
      }

      // 添加数据筛选条件（只添加有值的字段）
      if (queryParams.data.shopId !== undefined && queryParams.data.shopId !== null) {
        params.data.shopId = queryParams.data.shopId;
      }
      if (queryParams.data.categoryName) {
        params.data.categoryName = queryParams.data.categoryName;
      }
      if (
        queryParams.data.categoryStatus !== undefined &&
        queryParams.data.categoryStatus !== null
      ) {
        params.data.categoryStatus = queryParams.data.categoryStatus;
      }

      const response = await fetchCategoryList(params);

      if (response.code === 200) {
        tableData.value = response.result.list || [];
        total.value = response.result.total || 0;
      } else {
        message.error(response.msg || '查询失败');
        tableData.value = [];
        total.value = 0;
      }
    } catch (error) {
      console.error('加载分类列表失败:', error);
      message.error('加载分类列表失败，请稍后重试');
      tableData.value = [];
      total.value = 0;
    } finally {
      loading.value = false;
    }
  };

  // 查询
  const handleSearch = () => {
    queryParams.pageNum = 1;
    loadCategoryList();
  };

  // 打开新增分类弹窗
  const openAddCategoryModal = () => {
    isEdit.value = false;
    categoryModalTitle.value = '新增分类';
    categoryForm.shopFoodCategoryId = undefined;
    categoryForm.shopId = queryParams.data.shopId;
    categoryForm.categoryName = '';
    categoryForm.categoryStatus = 0;
    categoryForm.sort = 1;
    categoryForm.remark = '';
    categoryForm.translationLanguage = 'en';
    categoryForm.languageTranslationId = undefined;
    categoryForm.translationCategoryName = '';
    categoryModalVisible.value = true;
  };

  // 打开编辑分类弹窗
  const handleEditCategory = async (record: any) => {
    isEdit.value = true;
    categoryModalTitle.value = '编辑分类';
    categoryModalLoading.value = true;
    try {
      const resp = await fetchFoodCategoryDetail({
        shopFoodCategoryId: record.shopFoodCategoryId,
      });
      if (resp.code === 200 && resp.result) {
        const data = resp.result;
        categoryForm.shopFoodCategoryId = data.shopFoodCategoryId;
        // 编辑时带出所属店铺，供只读展示
        categoryForm.shopId = data.shopId as number | undefined;
        categoryForm.categoryName = data.categoryName || '';
        categoryForm.categoryStatus =
          (data.categoryStatus as 0 | 1 | undefined) !== undefined
            ? (data.categoryStatus as 0 | 1)
            : 0;
        categoryForm.sort = data.sort ?? 1;
        categoryForm.remark = data.remark || '';
        categoryForm.translationLanguage = 'en';
        categoryForm.languageTranslationId = undefined;
        categoryForm.translationCategoryName = '';
        await loadCategoryTranslation(data.shopFoodCategoryId, data.shopId);
        categoryModalVisible.value = true;
      } else {
        message.error(resp.msg || '获取分类详情失败');
      }
    } catch (error) {
      console.error('获取分类详情异常:', error);
      message.error('获取分类详情异常，请稍后重试');
    } finally {
      categoryModalLoading.value = false;
    }
  };

  // 保存分类（新增 / 编辑）
  const handleCategoryModalOk = async () => {
    // 新增时必须选择店铺
    if (!isEdit.value && !categoryForm.shopId) {
      message.warning('请选择店铺');
      return;
    }
    if (!categoryForm.categoryName) {
      message.warning('请输入分类名称');
      return;
    }
    if (categoryForm.sort < 0) {
      message.warning('排序值不能为负数');
      return;
    }

    categoryModalLoading.value = true;
    try {
      if (isEdit.value) {
        // 编辑
        const payload = {
          shopFoodCategoryId: categoryForm.shopFoodCategoryId,
          categoryName: categoryForm.categoryName,
          categoryType: 1,
          sort: categoryForm.sort,
          remark: categoryForm.remark,
        };
        const resp = await updateFoodCategory(payload);
        if (resp.code === 200) {
          message.success('编辑分类成功');
          await submitCategoryTranslation(categoryForm.shopFoodCategoryId);
          categoryModalVisible.value = false;
          await loadCategoryList();
        } else {
          message.error(resp.msg || '编辑分类失败');
        }
      } else {
        // 新增
        const payload = {
          shopId: categoryForm.shopId,
          categoryName: categoryForm.categoryName,
          categoryType: 1,
          categoryStatus: categoryForm.categoryStatus ?? 0,
          sort: categoryForm.sort,
          remark: categoryForm.remark,
        };
        const resp = await addFoodCategory(payload);
        if (resp.code === 200) {
          message.success('新增分类成功');
          await submitCategoryTranslation(Number(resp.result || 0));
          categoryModalVisible.value = false;
          await loadCategoryList();
        } else {
          message.error(resp.msg || '新增分类失败');
        }
      }
    } catch (error) {
      console.error('保存分类异常:', error);
      message.error('保存分类异常，请稍后重试');
    } finally {
      categoryModalLoading.value = false;
    }
  };

  // 取消分类弹窗
  const handleCategoryModalCancel = () => {
    categoryModalVisible.value = false;
    categoryForm.translationLanguage = 'en';
    categoryForm.languageTranslationId = undefined;
    categoryForm.translationCategoryName = '';
  };

  // 禁用 / 启用 分类
  const handleToggleCategoryStatus = async (record: any) => {
    const targetStatus = record.categoryStatus === 0 ? 1 : 0;
    try {
      const resp = await forbidFoodCategory({
        shopFoodCategoryId: record.shopFoodCategoryId,
        categoryStatus: targetStatus,
      });
      if (resp.code === 200) {
        message.success(targetStatus === 1 ? '分类已禁用' : '分类已启用');
        await loadCategoryList();
      } else {
        message.error(resp.msg || '更新分类状态失败');
      }
    } catch (error) {
      console.error('更新分类状态异常:', error);
      message.error('更新分类状态异常，请稍后重试');
    }
  };

  // 删除分类
  const handleDeleteCategory = async (record: any) => {
    try {
      const resp = await deleteFoodCategory({
        shopFoodCategoryId: record.shopFoodCategoryId,
      });
      if (resp.code === 200) {
        message.success('删除分类成功');
        await loadCategoryList();
      } else {
        message.error(resp.msg || '删除分类失败');
      }
    } catch (error) {
      console.error('删除分类异常:', error);
      message.error('删除分类异常，请稍后重试');
    }
  };

  // 查看分类详情
  const handleViewCategoryDetail = async (record: any) => {
    categoryDetailVisible.value = true;
    categoryDetailLoading.value = true;
    categoryDetail.value = null;
    try {
      const resp = await fetchFoodCategoryDetail({
        shopFoodCategoryId: record.shopFoodCategoryId,
      });
      if (resp.code === 200 && resp.result) {
        categoryDetail.value = resp.result;
      } else {
        message.error(resp.msg || '获取分类详情失败');
      }
    } catch (error) {
      console.error('获取分类详情异常:', error);
      message.error('获取分类详情异常，请稍后重试');
    } finally {
      categoryDetailLoading.value = false;
    }
  };

  // 重置
  const handleReset = () => {
    queryParams.pageNum = 1;
    queryParams.pageSize = 20;
    queryParams.createtimeBegin = '';
    queryParams.createtimeEnd = '';
    queryParams.data.categoryName = '';
    queryParams.data.categoryStatus = undefined;
    dateRange.value = null;
    loadCategoryList();
  };

  // 分页变化
  const handlePageChange = (page: number) => {
    queryParams.pageNum = page;
    loadCategoryList();
  };

  // 每页条数变化
  const handlePageSizeChange = (current: number, size: number) => {
    queryParams.pageNum = 1;
    queryParams.pageSize = size;
    loadCategoryList();
  };

  // 路由
  const router = useRouter();

  // 返回上一页
  const goBack = () => {
    router.back();
  };

  // 初始化
  onMounted(async () => {
    await loadShopList();
    await loadCategoryList();
  });

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_config_provider, { locale: _unref(zhCN) }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, { bordered: false }, {
            title: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_a_button, {
                  type: "text",
                  style: {"padding":"0"},
                  onClick: goBack
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_unref(ArrowLeftOutlined))
                  ]),
                  _: 1
                }),
                _cache[15] || (_cache[15] = _createElementVNode("span", { style: {"font-size":"18px","font-weight":"600"} }, "菜品分类管理", -1))
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                model: queryParams,
                layout: "inline",
                class: "search-form",
                onSubmit: [
                  handleSearch,
                  _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
                ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, { label: "店铺" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryParams.data.shopId,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryParams.data.shopId) = $event)),
                        disabled: "",
                        placeholder: "请选择店铺",
                        style: {"width":"200px"},
                        onChange: _unref(cacheSelectedShop)
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shopList.value, (shop) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: shop.shopId,
                              value: shop.shopId
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(shop.shopName), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "分类名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryParams.data.categoryName,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryParams.data.categoryName) = $event)),
                        placeholder: "请输入分类名称",
                        "allow-clear": "",
                        style: {"width":"200px"}
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "状态" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryParams.data.categoryStatus,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryParams.data.categoryStatus) = $event)),
                        placeholder: "请选择状态",
                        "allow-clear": "",
                        style: {"width":"120px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select_option, { value: 0 }, {
                            default: _withCtx(() => _cache[16] || (_cache[16] = [
                              _createTextVNode("正常", -1)
                            ])),
                            _: 1,
                            __: [16]
                          }),
                          _createVNode(_component_a_select_option, { value: 1 }, {
                            default: _withCtx(() => _cache[17] || (_cache[17] = [
                              _createTextVNode("禁用", -1)
                            ])),
                            _: 1,
                            __: [17]
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, { label: "创建时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_range_picker, {
                        value: dateRange.value,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((dateRange).value = $event)),
                        format: "YYYY-MM-DD",
                        style: {"width":"240px"},
                        onChange: handleDateRangeChange
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        "html-type": "submit",
                        loading: loading.value
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(SearchOutlined))
                        ]),
                        default: _withCtx(() => [
                          _cache[18] || (_cache[18] = _createTextVNode(" 查询 ", -1))
                        ]),
                        _: 1,
                        __: [18]
                      }, 8, ["loading"]),
                      _createVNode(_component_a_button, {
                        style: {"margin-left":"8px"},
                        onClick: handleReset
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_unref(ReloadOutlined))
                        ]),
                        default: _withCtx(() => [
                          _cache[19] || (_cache[19] = _createTextVNode(" 重置 ", -1))
                        ]),
                        _: 1,
                        __: [19]
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: openAddCategoryModal
                }, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createTextVNode(" 新增分类 ", -1)
                  ])),
                  _: 1,
                  __: [20]
                })
              ]),
              _createVNode(_component_a_table, {
                columns: columns,
                "data-source": tableData.value,
                loading: loading.value,
                pagination: false,
                "row-key": "shopFoodCategoryId",
                scroll: { x: 'max-content' }
              }, {
                bodyCell: _withCtx(({ column, record }) => [
                  (column.key === 'categoryStatus')
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: record.categoryStatus === 0 ? 'green' : 'red'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(record.categoryStatus === 0 ? '正常' : '禁用'), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"]))
                    : (column.key === 'shopName')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(getShopName(record.shopId)), 1))
                      : (column.key === 'createTime')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(formatDateTime(record.createTime)), 1))
                        : (column.key === 'actions')
                          ? (_openBlock(), _createBlock(_component_a_space, { key: 3 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "link",
                                  size: "small",
                                  onClick: ($event: any) => (handleEditCategory(record))
                                }, {
                                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                                    _createTextVNode(" 编辑 ", -1)
                                  ])),
                                  _: 2,
                                  __: [21]
                                }, 1032, ["onClick"]),
                                _createVNode(_component_a_popconfirm, {
                                  title: record.categoryStatus === 0 ? '确认禁用该分类？' : '确认启用该分类？',
                                  "ok-text": "是",
                                  "cancel-text": "否",
                                  onConfirm: ($event: any) => (handleToggleCategoryStatus(record))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_button, {
                                      type: "link",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(record.categoryStatus === 0 ? '禁用' : '启用'), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["title", "onConfirm"]),
                                _createVNode(_component_a_popconfirm, {
                                  title: "确认删除该分类？",
                                  "ok-text": "是",
                                  "cancel-text": "否",
                                  onConfirm: ($event: any) => (handleDeleteCategory(record))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_button, {
                                      type: "link",
                                      danger: "",
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                                        _createTextVNode("删除", -1)
                                      ])),
                                      _: 1,
                                      __: [22]
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onConfirm"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["data-source", "loading"]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_pagination, {
                  current: queryParams.pageNum,
                  "onUpdate:current": _cache[5] || (_cache[5] = ($event: any) => ((queryParams.pageNum) = $event)),
                  "page-size": queryParams.pageSize,
                  "onUpdate:pageSize": _cache[6] || (_cache[6] = ($event: any) => ((queryParams.pageSize) = $event)),
                  total: total.value,
                  "show-total": (total) => `共 ${total} 条`,
                  "show-size-changer": true,
                  "page-size-options": ['10', '20', '50', '100'],
                  onChange: handlePageChange,
                  onShowSizeChange: handlePageSizeChange
                }, null, 8, ["current", "page-size", "total", "show-total"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["locale"])
    ]),
    _createVNode(_component_a_modal, {
      open: categoryModalVisible.value,
      "onUpdate:open": _cache[13] || (_cache[13] = ($event: any) => ((categoryModalVisible).value = $event)),
      title: categoryModalTitle.value,
      "confirm-loading": categoryModalLoading.value,
      "ok-text": "保存",
      "cancel-text": "取消",
      width: 640,
      "wrap-class-name": "category-modal",
      onOk: handleCategoryModalOk,
      onCancel: handleCategoryModalCancel
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { layout: "vertical" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "店铺",
              required: ""
            }, {
              default: _withCtx(() => [
                (!isEdit.value)
                  ? (_openBlock(), _createBlock(_component_a_select, {
                      key: 0,
                      value: categoryForm.shopId,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((categoryForm.shopId) = $event)),
                      disabled: "",
                      placeholder: "请选择店铺"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shopList.value, (shop) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: shop.shopId,
                            value: shop.shopId
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(shop.shopName), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"]))
                  : (_openBlock(), _createBlock(_component_a_input, {
                      key: 1,
                      value: getShopName(categoryForm.shopId),
                      disabled: "",
                      placeholder: "店铺"
                    }, null, 8, ["value"]))
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "分类名称",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: categoryForm.categoryName,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((categoryForm.categoryName) = $event)),
                  placeholder: "请输入分类名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "翻译语言" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: categoryForm.translationLanguage,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((categoryForm.translationLanguage) = $event)),
                  placeholder: "请选择翻译语言",
                  onChange: handleCategoryTranslationLanguageChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(translationLanguageOptions, (language) => {
                      return _createVNode(_component_a_select_option, {
                        key: language.value,
                        value: language.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(language.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "分类翻译名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: categoryForm.translationCategoryName,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((categoryForm.translationCategoryName) = $event)),
                  placeholder: "请输入分类翻译名称"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "排序" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: categoryForm.sort,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((categoryForm.sort) = $event)),
                  min: 0,
                  style: {"width":"100%"},
                  placeholder: "请输入排序（数字，越小越靠前）"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: categoryForm.remark,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((categoryForm.remark) = $event)),
                  rows: 3,
                  maxlength: 200,
                  "show-count": "",
                  placeholder: "请输入备注"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open", "title", "confirm-loading"]),
    _createVNode(_component_a_modal, {
      open: categoryDetailVisible.value,
      "onUpdate:open": _cache[14] || (_cache[14] = ($event: any) => ((categoryDetailVisible).value = $event)),
      title: "分类详情",
      footer: null,
      width: 520
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_spin, { spinning: categoryDetailLoading.value }, {
          default: _withCtx(() => [
            (categoryDetail.value)
              ? (_openBlock(), _createBlock(_component_a_descriptions, {
                  key: 0,
                  bordered: "",
                  column: "1",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_descriptions_item, { label: "分类ID" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(categoryDetail.value.shopFoodCategoryId), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "分类名称" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(categoryDetail.value.categoryName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "状态" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_tag, {
                          color: categoryDetail.value.categoryStatus === 0 ? 'green' : 'red'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(categoryDetail.value.categoryStatus === 0 ? '正常' : '禁用'), 1)
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "排序" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(categoryDetail.value.sort), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "备注" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(categoryDetail.value.remark || '-'), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "创建时间" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(formatDateTime(categoryDetail.value.createTime)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "修改时间" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(formatDateTime(categoryDetail.value.modifyTime)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, "暂无数据"))
          ]),
          _: 1
        }, 8, ["spinning"])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})